module.exports = "<div class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <div class=\"col-lg-6\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"visualization.options.controls.enabled\">\n        Hide Pivot Controls\n      </label>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/pivot/pivottable-editor.html
// module id = 700
// module chunks = 1